import Early from '../../../common/icons/Early';
import Morning from '../../../common/icons/Morning';
import Noon from '../../../common/icons/Noon';
import Afternoon from '../../../common/icons/Afternoon';
import Evening from '../../../common/icons/Evening';
import Weekends from '../../../common/icons/Weekends';

export const options = [
  {
    id: 'early',
    title: 'Early',
    description: 'Before 9am',
    icon: Early,
  },
  {
    id: 'morning',
    title: 'Morning',
    description: '9am - 12pm',
    icon: Morning,
  },
  {
    id: 'noon',
    title: 'Noon',
    description: '12pm - 2pm',
    icon: Noon,
  },
  {
    id: 'afternoon',
    title: 'Afternoon',
    description: '2pm - 5pm',
    icon: Afternoon,
  },
  {
    id: 'evening',
    title: 'Evening',
    description: 'After 5pm',
    icon: Evening,
  },
  {
    id: 'weekends',
    title: 'Weekends',
    description: 'Sat - Sun',
    icon: Weekends,
  },
];
